type BuildEnv = 'er' | 'wa' | 'wf' | 'all' | undefined;

export const getApiBaseUrl = (): string => {
  const env = process.env.REACT_APP_BUILD_NAME as BuildEnv;
  const isProductionBuild = process.env.NODE_ENV === 'production';

  if (!isProductionBuild) {
    return '/';
  }

  if (env === 'er') {
    return process.env.REACT_APP_ER_API_HOST || '/';
  }

  if (env === 'wa') {
    return process.env.REACT_APP_WA_API_HOST || '/';
  }

  if (env === 'wf') {
    return process.env.REACT_APP_WF_API_HOST || '/';
  }

  return '/';
};
